<template>
  <div>
    <!-- 操作 -->
    <div class="operate" v-if="activeName != 'delete'">
      <!--全选  -->
      <el-checkbox v-model="checked" style="margin-right: 10px" @change="allChecked">{{ $t("message.allChecked")
      }}</el-checkbox>
      <!-- 取消全选 -->
      <el-button size="mini" type="primary" class="dark" @click="cancelAllChecked">
        {{ $t("message.cancelAllChecked") }}
      </el-button>
      <!-- 再提一单 -->
      <el-button size="mini" type="primary" class="secondary" @click="raiseAnotherOrder" v-if="isAuth(154)">
        {{ $t("message.raiseAnotherOrder") }}
      </el-button>
      <!-- 提出新订单 -->
      <el-button size="mini" type="primary" class="secondary" @click="placeANewOrder" v-if="isAuth(154)">
        {{ $t("message.placeANewOrder") }}
      </el-button>
      <!-- 删除 -->
      <el-button size="mini" type="primary" class="dark" @click="deleteFromOrder" v-if="isAuth(156)">
        {{ $t("message.delete") }}
      </el-button>
      <!-- 同ID商品 -->
      <el-button size="mini" type="primary" class="secondary" @click="sameID">{{ $t("message.productWithTheSameId")
      }}
      </el-button>
      <!-- 同店铺商品 -->
      <el-button size="mini" type="primary" class="secondary" @click="sameShop">{{ $t("message.sameStoreProduct") }}
      </el-button>
      <!-- 商品监控录入 -->
      <el-button size="mini" type="success" @click="commodityMonitoringEntry">
        {{ $t("message.commodityMonitoringEntry") }}
      </el-button>
      <!-- 复制选中商品信息 -->
      <el-button size="mini" type="primary" class="dark" @click="copyText">
        {{ $t("message.copySelectedProductInformation") }}
      </el-button>
      <!-- 同分类分组 -->
      <el-button size="mini" type="primary" class="secondary" @click="homogeneousGrouping(isHomogeneousGrouping)">
        {{ $t("message.homogeneousGrouping") }}
      </el-button>
      <!-- 订单拆单 -->
      <el-button size="mini" type="primary" class="secondary" @click="splitOrder" v-if="status < 30">
        {{ $t("message.orderUnpacking") }}
      </el-button>
      <!-- 加入商品库 -->
      <el-button size="mini" type="primary" class="secondary" @click="inventoryBatchSave" v-if="isAuth(566)">
        {{ $t("message.joinProductLibrary") }}
      </el-button>
      <!-- 下单数 -->
      <span style="margin-left:10px;font-size:20px;color:#B4272D">{{ $t("message.lowerSingular")
      }}:{{ xiandanNum }}</span>
      <!-- 报价数 -->
      <span style="margin-left:10px;font-size:20px;color:#B4272D">{{ $t("message.quotedPriceNum")
      }}:{{ baojiaNum }}</span>
      <!-- 右边按钮 -->
      <!-- 直接付款 -->
      <el-button size="mini" type="primary" class="fr"
        v-if="((status == 22 || status == 30) && isAuth(164) && detail.user.is_pay_authorized) || ((status == 22 || status == 30) && detail.user.credit > 0)"
        @click="adminOrderPay">
        {{ $t("message.directPayments") }}
      </el-button>
      <!-- 退回待报价 -->
      <el-button size="mini" type="primary" class="fr" v-if="status == 30 && isAuth(165)" @click="backToWaitOffer">
        {{ $t("message.returnToBeQuoted") }}
      </el-button>
      <!--  业务提出-->
      <el-button size="mini" type="primary" class="fr" v-if="status == 20 && isAuth(155)" @click="submitTranslate(0)">
        {{ $t("message.businessSbumit") }}
      </el-button>
      <!--  临时保存-->
      <el-button size="mini" type="primary" class="fr primary" v-if="status == 20 && isAuth(155)"
        @click="submitTranslate(1)">
        {{ $t("message.temporaryStorage") }}
      </el-button>
      <!--  撤回翻译-->
      <el-button size="mini" type="primary" class="fr" v-if="status == 20" @click="isYEditing(0)">撤回翻译
      </el-button>
      <!-- 采购提出 -->
      <el-button size="mini" type="primary" class="fr" v-if="status == 21 && isAuth(157)" @click="submitConfirm(0)">
        {{ $t("message.procurement") }}
      </el-button>
      <!-- 提出报价 -->
      <el-button size="mini" type="primary" class="fr" v-if="status == 22 && isAuth(163)" @click="makeAnOffer"
        style="margin-right: 8px;">
        {{ $t("message.makeAnOffer") }}
      </el-button>
      <!-- 临时保存 -->
      <el-button size="mini" type="primary" class="secondary fr" @click="makeAnOfferTemporaryStorage"
        v-if="status == 22 && isAuth(163)">
        {{ $t("message.temporaryStorage") }}
      </el-button>
      <!-- 退给采购 -->
      <el-button size="mini" type="primary" class="fr" v-if="status == 22 && isAuth(162)" @click="backToWaitConfirm">
        {{ $t("message.returnToPurchase") }}
      </el-button>
      <!-- 临时保存 -->
      <el-button size="mini" type="primary" class="secondary fr" @click="temporaryStorage"
        v-if="status == 21 && isAuth(157)">
        {{ $t("message.temporaryStorage") }}
      </el-button>
      <!-- 获取店铺信息 -->
      <!-- <el-button size="mini" type="primary" class="secondary fr">{{ $t("message.obtainStoreInformation") }}
        </el-button> -->
      <!-- 退给业务 -->
      <el-button size="mini" type="primary" class="fr" v-if="status == 21 && isAuth(159)" @click="backToWaitTranslate">
        {{ $t("message.returnService") }}
      </el-button>
      <!-- 客户页面链接 -->
      <el-button size="mini" type="primary" class="fr"
        @click="copy('https://www.rakumart.com/OrderDetails?order_sn=' + order_sn)">
        {{ $t("message.userLink") }}
      </el-button>
    </div>
    <!-- 追加商品表单 -->
    <addGoods :isUser_id="true" ref="addGoods" />
    <!-- 监控商品 -->
    <monitorProductSettings ref="monitorProductSettings" :checkedList="checkedList" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import addGoods from "./addGoods";
import monitorProductSettings from "./monitorProductSettings";
export default {
  components: { addGoods, monitorProductSettings },
  props: {
    activeName: { type: String },
    xiandanNum: { type: Number },
    baojiaNum: { type: Number },
    checkedList: { type: Array },
    order_detail: { type: Array },
    domesticSubtotal: { type: Number }
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
      detail: (state) => state.orderDetail.detail,
      orderStatusList: (state) => state.orderStatusList,
      rate: (state) => state.rate,
      status: (state) => state.orderDetail.detail.status,

    }),
  },
  data() {
    return {
      checked: false,
      userRole: localStorage.getItem('japanUserRoleStatus') == 1, //是否是业务工种
      order_sn: this.$route.query.order_sn,
      isHomogeneousGrouping: true,
    };
  },
  methods: {
    //    全选
    allChecked() {
      this.checkedList = []
      this.detail.order_detail.forEach((item) => {
        item.checked = this.checked;
        if (item.checked) {
          this.checkedList.push(item)
        }
      });
      this.$forceUpdate();
    },
    // 取消全选
    cancelAllChecked() {
      this.checkedList = []
      this.checked = false
      this.detail.order_detail.forEach((item) => {
        item.checked = false

      });
      this.$forceUpdate();
    },
    //新增商品
    placeANewOrder() {
      this.$refs.addGoods.dialogVisible = true
      this.$refs.addGoods.setData(
        this.detail.user.id,
        this.detail.user.realname,
      )
    },
    // 删除商品
    deleteFromOrder() {
      let ids = []
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          ids.push(item.id)
        }
      });
      if (ids == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      this.$confirm(
        this.$t("message.whetherToDeleteTheSelectedOrder"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            ids: ids
          }
          this.$api.orderApi.deleteFromOrder(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.orderDetails();
            this.checked = false
          });
        })
        .catch(() => { });
    },
    //排序
    homogeneousGrouping(flag) {
      if (flag) {
        this.$confirm(
          '按分类分组后，当前页面编辑的信息如果没有进行保存将会重置，请保存好再排序，是否确认进行分组排序',
          this.$t("message.hint"),
          {
            confirmButtonText: this.$t("message.ok"), //确定
            cancelButtonText: this.$t("message.cancel"), //取消
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.detail.order_detail = []
            this.order_detail.forEach(item => {
              if (item.from_platform == '1688') {
                this.detail.order_detail.push(item)
              }
            })
            this.order_detail.forEach(item => {
              if (item.from_platform == 'taobao') {
                this.detail.order_detail.push(item)
              }
            })
            this.order_detail.forEach(item => {
              if (item.from_platform == 'tmall') {
                this.detail.order_detail.push(item)
              }
            })
            this.order_detail.forEach(item => {
              if (item.from_platform == 'wangyi') {
                this.detail.order_detail.push(item)
              }

            })


            this.isHomogeneousGrouping = false
            this.$forceUpdate();
          })
          .catch(() => { });
      } else {
        this.isHomogeneousGrouping = true
        this.detail.order_detail = JSON.parse(JSON.stringify(this.order_detail))
      }

    },
    sameShop() {
      let list = [];
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      list.forEach((item) => {
        this.detail.order_detail.forEach((items) => {
          if (item.shop_id == items.shop_id) {
            items.checked = true;
          }
        });
      });
      this.$forceUpdate();
    },
    // 同ID商品
    sameID() {
      let list = [];
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      list.forEach((item) => {
        this.detail.order_detail.forEach((items) => {
          if (item.goods_id == items.goods_id) {
            items.checked = true;
          }
        });
      });
      this.$forceUpdate();
    },
    //订单拆单
    splitOrder() {
      let datas = {
        orderDetailIds: []
      }
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          datas.orderDetailIds.push(item.id)
        }
      });
      if (datas.orderDetailIds == false) return this.$message.error(this.$t('message.selectableOperational'))
      this.$confirm('此操作将选中的商品拆分成一个新订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.orderApi.splitOrder(datas).then(res => {
          this.$parent.orderDetails();
          this.copy(res.data)
          this.$alert("新订单的单号:" + res.data, "提示", {
            confirmButtonText: "确定",
            center: true,
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    //商品监控
    commodityMonitoringEntry() {
      console.log(this.checkedList);

      if (this.checkedList == false) return this.$message.error('未选择商品')
      this.$refs.monitorProductSettings.dialogVisible = true
    },
    //复制选择商品信息
    copyText() {
      let list = []
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      if (list.length === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      let copyUrl = "";
      list.forEach((item) => {
        let size = "";
        if (item.detail.length > 0) {
          if (this.status <= 20) {
            item.detail.forEach((items) => {
              size += items.key + ":" + items.value + "  ";
            });
          } else {
            item.detail_y.forEach((items) => {
              size += items.key + ":" + items.value + "  ";
            });
          }
        }
        if (this.userRole == 1) { // 业务复制商品信息
          copyUrl += `${this.order_sn}\n${item.sorting}番   ${item.link}\n`;
        } else {
          copyUrl += `${size} 数量: ${item.num}\n`;
        }
      });
      //每一行的数据
      this.copy(copyUrl)
    },
    //加入商品库
    inventoryBatchSave() {
      let datas = {
        user_id: this.detail.user_id,
        data: []
      }
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          item.shop_type = item.from_platform
          item.img_url = item.pic
          datas.data.push({
            shop_type: item.from_platform,
            img_url: item.pic,
            shop_id: item.shop_id,
            goods_id: item.goods_id,
            num: item.num,
            price: item.price,
            sku_id: item.sku_id,
            spec_id: item.spec_id,
            shop_name: item.shop_name,
            goods_title: item.goods_title,
            detail: JSON.stringify(item.detail),
            option: JSON.stringify(item.option),
            note: '',
            for_sn: '',
            detail_edit: '',
            copy_from_id: '',
          });
        }
      });
      if (datas.data == false) return this.$message.error('请选择商品')
      this.$api.clienteleApi.inventoryBatchSave(datas).then(res => {
        this.$message.success(res.msg)

      })

    },
    // 临时保存
    temporaryStorage() {
      if (this.status == 21) {
        this.submitConfirm(1);
      }
    },
    // 业务提出翻译
    submitTranslate(is_temp) {
      let list = this.detail.order_detail;
      for (let i = 0; i < list.length; i++) {
        // if ((list[i].client_remark != "" && list[i].client_remark != null) && list[i].y_remark == "") {
        //   this.$alert("有客户商品备注未翻译，请翻译后提交", "提示", {
        //     confirmButtonText: "确定",
        //     center: true,
        //   });
        //   return;
        // }
      }
      this.addMadeInChina(this.detail.order_detail)
      let datas = {
        data: JSON.stringify(this.detail),
        is_temp
      };
      this.$api.orderApi.submitTranslate(datas).then((res) => {
        this.$message.success(res.msg);
        setTimeout(() => {
          window.open("about:blank", "_top").close();
        }, 1000)
      });
    },
    // 采购确认提出
    submitConfirm(type) {
      let data = {
        order_sn: this.detail.order_sn,
        order_detail: [],
      };
      let list = this.detail.order_detail;
      for (let i = 0; i < list.length; i++) {
        data.order_detail.push({
          id: list[i].id,
          confirm_num: list[i].confirm_num,
          confirm_price: list[i].confirm_price,
          confirm_freight: list[i].confirm_freight,
          confirm_dicker_price: list[i].confirm_dicker_price,
          confirm_dicker_freight: list[i].confirm_dicker_freight,
          g_remark: list[i].g_remark.trim(),
          volume: list[i].length + "x" + list[i].width + "x" + list[i].height,
          weight: list[i].weight * 1000,
        });
      }
      let datas = {
        is_temp: type,
        data: JSON.stringify(data),
      };
      this.$api.orderApi.submitConfirm(datas).then((res) => {
        this.$message.success(res.msg);
        if (type != 1) {
          this.$parent.orderDetails();
        }

        this.checked = false;
      });
    },
    //业务报价
    makeAnOffer() {
      let list = JSON.parse(JSON.stringify(this.detail.order_detail));
      let str = ''
      for (let i = 0; i < list.length; i++) {
        // 报价数量0 option清0
        if (list[i].offer_num == 0) {
          if (list[i].option != null) {
            list[i].option.forEach(item => {
              item.num = 0
            })
          }
        }

        if (list[i].y_reply == '' && list[i].g_remark != '') {
          str += list[i].sorting + ','
        }
        list[i].confirm_price = list[i].offer_price;
        list[i].confirm_freight = list[i].offer_freight;
        list[i].confirm_num = list[i].offer_num;
        list[i].volume = list[i].length + "x" + list[i].width + "x" + list[i].height
        list[i].weight = list[i].weight * 1000
      }
      // 分批付款
      if (this.detail.part_pay_status && this.detail.order_part_pay == false) {
        return this.$alert('当前订单标识为分配付款，请确认付款方式在报价。', '提示', {
          confirmButtonText: '确定',
          center: true,
          callback: action => {
          }
        });
      }
      // console.log(list);
      if (str) {
        this.$confirm(str + '番未翻译采购备注， 是否继续报价?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.submitOffer(list)
        }).catch(() => {
        });
      } else {
        this.submitOffer(list)
      }
    },
    // 报价
    submitOffer(list) {
      let datas = {
        order_sn: this.detail.order_sn,
        other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
        other_price_remark: this.detail.other_price_remark,
        y_reply: this.detail.y_reply,
        y_remark: this.detail.y_remark,
        predict_logistics_price: this.detail.predict_logistics_price,
        order_detail: this.priceOption(list),

        order_part_pay: this.detail.part_pay_status
      };
      console.log(datas);
      // let option = []
      // this.priceOption(list).forEach(item => {
      //   option.push(item.option)
      // })
      // console.log(datas, option);
      // return
      this.$api.orderApi
        .submitOffer({ data: JSON.stringify(datas) })
        .then((res) => {
          this.$message.success(res.msg);
          this.checked = false;
          setTimeout(() => {
            window.open("about:blank", "_top").close();
          }, 1000)
        });
    },
    // 退回待报价
    backToWaitOffer() {
      let datas = {
        order_sn_set: [this.detail.order_sn],
      };

      this.$confirm(
        this.$t("message.isReturnToBeQuoted"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.backToWaitOffer(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.orderDetails();
          });
        })
        .catch(() => { });
    },
    // -回退到待翻译
    backToWaitTranslate() {
      let datas = {
        order_sn_set: [this.detail.order_sn],
      };
      this.$confirm(
        this.$t("message.isBackToWaitTranslate"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.backToWaitTranslate(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.orderDetails();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 退给采购
    backToWaitConfirm() {
      this.$confirm(
        this.$t("message.whetherToReturnThisOrderToPurchaseForReconfirmation"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let list = JSON.parse(JSON.stringify(this.detail.order_detail));
          for (let i = 0; i < list.length; i++) {
            // 报价在库数 为0， option清空
            if (list[i].offer_num == 0) {
              list[i].option = []
            }
            list[i].confirm_price = list[i].offer_price;
            list[i].confirm_freight = list[i].offer_freight;
            list[i].confirm_num = list[i].offer_num;
            list[i].volume = list[i].length + "x" + list[i].width + "x" + list[i].height
            list[i].weight = list[i].weight * 1000
          }
          let datas = {
            order_sn: this.detail.order_sn,
            other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
            other_price_remark: this.detail.other_price_remark,
            y_reply: this.detail.y_reply,
            y_remark: this.detail.y_remark,
            predict_logistics_price: this.detail.predict_logistics_price,
            order_detail: list,
          };
          this.$api.orderApi.backToWaitConfirm({ data: JSON.stringify(datas) }).then((res) => {
            this.$message.success(res.msg);
            this.$parent.orderDetails();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //再来一单：选中商品直接带入预览，保留辅料标识和辅料绑定列表
    raiseAnotherOrder() {
      if (this.checkedList == false) return this.$message.error(this.$t('message.selectableOperationalList'))
      let routeUrl = this.$router.resolve({
        path: "/orderPreview?userID=" + this.detail.user_id + "&type=raiseAnotherOrder",
      });
      const orderList = this.checkedList.map(item => {
        const isMaterial = Number(item.is_material) === 1 || item.is_material === true
        const materialId = isMaterial
          ? (item.material_id || (item.material && item.material.id) || '')
          : ''
        return {
          ...item,
          material_id: materialId,
          is_material: isMaterial,
          material: isMaterial ? (item.material || null) : null,
          material_detail: isMaterial ? (item.material_detail || item.material || null) : null,
          material_bind: Array.isArray(item.material_bind)
            ? JSON.parse(JSON.stringify(item.material_bind))
            : [],
        }
      })
      let data = {
        orderList,
        y_reply: this.detail.y_reply,
        y_remark: this.detail.y_remark,
      }
      window.open(routeUrl.href, JSON.stringify(data));
    },
    //撤回翻译
    isYEditing(type) {
      let datas = {
        order_sn: this.order_sn,
        is_y_editing: type
      }
      this.$api.orderApi.isYEditing(datas).then(res => {
        this.$message.success(res.msg)
        if (type == 0) {
          this.$parent.orderDetails()
        }
      })
    },
    // 报价临时保存
    makeAnOfferTemporaryStorage() {
      //转寄订单-标记订单手否收商品金额及手续费收取规则
      if (this.detail.type == 2) {
        let updateOrderPayRule = {
          order_sn: this.order_sn,
          goods_fee_rule: this.detail.goods_fee_rule ? 1 : 0,
          service_fee_rule: this.detail.service_fee_rule ? 1 : 0,
        }
        this.$api.orderApi
          .updateOrderPayRule(updateOrderPayRule)
      }
      let list = JSON.parse(JSON.stringify(this.detail.order_detail));
      let str = ''
      for (let i = 0; i < list.length; i++) {
        // 报价数量0 option清0
        if (list[i].offer_num == 0) {
          if (list[i].option != null) {
            list[i].option.forEach(item => {
              item.num = 0
            })
          }
        }
        if (list[i].y_reply == '' && list[i].g_remark != '') {
          str += list[i].sorting + ','
        }
        list[i].confirm_price = list[i].offer_price;
        list[i].confirm_freight = list[i].offer_freight;
        list[i].confirm_num = list[i].offer_num;
        list[i].volume = list[i].length + "x" + list[i].width + "x" + list[i].height
        list[i].weight = list[i].weight * 1000
      }
      let datas = {
        order_sn: this.detail.order_sn,
        other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
        other_price_remark: this.detail.other_price_remark,
        y_reply: this.detail.y_reply,
        y_remark: this.detail.y_remark,
        predict_logistics_price: this.detail.predict_logistics_price,
        order_detail: this.priceOption(list),
        order_part_pay: this.detail.part_pay_status
      };
      this.$api.orderApi
        .submitOffer({ data: JSON.stringify(datas), is_temp: 1, })
        .then((res) => {
          this.$message.success(res.msg);

        });
    },
    //直接付款
    adminOrderPay() {
      //转寄订单-标记订单手否收商品金额及手续费收取规则
      if (this.detail.type == 2) {
        let updateOrderPayRule = {
          order_sn: this.order_sn,
          goods_fee_rule: this.detail.goods_fee_rule ? 1 : 0,
          service_fee_rule: this.detail.service_fee_rule ? 1 : 0,
        }
        this.$api.orderApi
          .updateOrderPayRule(updateOrderPayRule)
      }

      let amount = 0 // 付款的金额
      if (this.detail.part_pay_status) {
        // 分批付款
        if (this.detail.order_part_pay == false) {
          return this.$alert('当前订单标识为分配付款，请确认付款方式在报价。', '提示', {
            confirmButtonText: '确定',
            center: true,
            callback: action => {

            }
          });
        }
        amount = this.order_part_pay()
      } else {
        // 全款
        amount = (this.domesticSubtotal * this.rate).toFixed(0)
      }
      if (this.status == 22) {
        let list = JSON.parse(JSON.stringify(this.detail.order_detail));
        let str = ''
        for (let i = 0; i < list.length; i++) {
          if (list[i].offer_num == 0) {
            if (list[i].option != null) {
              list[i].option.forEach(item => {
                item.num = 0
              })
            }
          }
          if (!list[i].offer_price) {
            this.$alert("报价单价不能为0或者为空", "提示", {
              confirmButtonText: "确定",
              center: true,
            });
            return;
          }
          if (list[i].y_reply == '' && list[i].g_remark != '') {
            str += list[i].sorting + ','
          }

          // 报价在库数 为0， option清空
          // if (list[i].offer_num == 0) {
          //   list[i].option = []
          // }
          list[i].confirm_price = list[i].offer_price;
          list[i].confirm_freight = list[i].offer_freight;
          list[i].confirm_num = list[i].offer_num;
          list[i].volume = list[i].length + "x" + list[i].width + "x" + list[i].height
          list[i].weight = list[i].weight * 1000
        }


        if (str) {
          let datas = {
            order_sn: this.detail.order_sn,
            other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
            other_price_remark: this.detail.other_price_remark,
            y_reply: this.detail.y_reply,
            y_remark: this.detail.y_remark,
            predict_logistics_price: this.detail.predict_logistics_price,
            order_detail: this.priceOption(list),
            order_part_pay: this.detail.part_pay_status
          };

          this.$alert(`<p>客户可用余额:<b style="color:red"> ${this.detail.user.balance}</b>付款后余额:<b style="color:red"> ${this.detail.user.balance - amount} </b> </p>
      <p> 是否直接残金付款?</p>`, '直接付款', {
            confirmButtonText: '确定',
            center: true,
            dangerouslyUseHTMLString: true,
            callback: action => {
              if (action == 'confirm') {
                this.$api.orderApi
                  .submitOffer({ data: JSON.stringify(datas) })
                  .then((res) => {
                    let data = {
                      order_sn: this.order_sn
                    }
                    this.loading = true;
                    setTimeout(() => {
                      this.loading = false
                      this.$api.clienteleApi.orderPay(data).then((res) => {
                        this.$message.success(res.msg);
                        this.$api.orderApi.updateStatus({ order_sn: this.detail.order_sn, }).then(res => {
                          setTimeout(() => {
                            window.open("about:blank", "_top").close();
                          }, 1000)
                        })
                      })
                    }, 3000)

                  });
              }
            }
          });

        } else {
          let datas = {
            order_sn: this.detail.order_sn,
            other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
            other_price_remark: this.detail.other_price_remark,
            y_reply: this.detail.y_reply,
            y_remark: this.detail.y_remark,
            predict_logistics_price: this.detail.predict_logistics_price,
            order_detail: this.priceOption(list),
            order_part_pay: this.detail.part_pay_status
          };
          this.$alert(`<p>客户可用余额:<b style="color:red"> ${this.detail.user.balance}</b>付款后余额:<b style="color:red"> ${this.detail.user.balance - amount}</b></p>
      <p> 是否直接残金付款?</p>`, '直接付款', {
            confirmButtonText: '确定',
            center: true,
            dangerouslyUseHTMLString: true,
            callback: action => {
              if (action == 'confirm') {
                this.$api.orderApi
                  .submitOffer({ data: JSON.stringify(datas) })
                  .then((res) => {
                    let data = {
                      order_sn: this.order_sn
                    }
                    this.loading = true;
                    setTimeout(() => {
                      this.loading = false
                      this.$api.clienteleApi.orderPay(data).then((res) => {
                        this.$message.success(res.msg);
                        this.$api.orderApi.updateStatus({ order_sn: this.detail.order_sn, }).then(res => {
                          setTimeout(() => {
                            window.open("about:blank", "_top").close();
                          }, 1000)
                        })
                      })
                    }, 3000)

                  });
              }
            }
          });
        }
      } else {
        this.$alert(`<p>客户可用余额:<b style="color:red"> ${this.detail.user.balance}</b>付款后余额:<b style="color:red"> ${this.detail.user.balance - amount}</b></p>
      <p> 是否直接残金付款?</p>`, '直接付款', {
          confirmButtonText: '确定',
          center: true,
          dangerouslyUseHTMLString: true,
          callback: action => {
            if (action == 'confirm') {
              let data = {
                order_sn: this.order_sn
              }
              this.$api.clienteleApi.orderPay(data).then((res) => {
                this.$message.success(res.msg);
                this.$api.orderApi.updateStatus({ order_sn: this.detail.order_sn, }).then(res => {
                  setTimeout(() => {
                    window.open("about:blank", "_top").close();
                  }, 1000)
                })
              })
            }
          }
        });
      }
    },
    //详细检品，系统自动根据报价单价修改option
    //単価１５元以下の商品１点1.5元
    //単価３０元以下の商品１点２元
    priceOption(list) {
      list.forEach(item => {
        if (item.option != null) {
          item.option.forEach((opti, i) => {
            // 详细检品低于30重新计算
            if (opti.name == '详细检品' || opti.name == '详细检品(单价)') {
              if (item.offer_price <= 30) {
                item.option.push(
                  {
                    auto_calculate: 1,
                    checked: true,
                    edit: false,
                    is_overstep: 0,
                    name: "详细检品(单价)",
                    name_translate: "詳細検品",
                    price_type: 0,
                    price: item.offer_price > 15 ? 2 : 1.5,
                    num: opti.num,
                    unit: '元'
                  }
                )
                item.option.splice(i, 1)

              }
            }
            // 数组去重
            var hash = {};
            item.option = item.option.reduce(function (items, next) {
              hash[next.name]
                ? ""
                : (hash[next.name] = true && items.push(next));
              return items;
            }, []);
          })
        }
      })
      list.forEach(item => {

        if (item.option != null) {
          item.option.forEach((opti, i) => {
            // 拍照张数计算
            if (opti.name == '拍照') {
              let price = 0
              if (opti.num == 1) {
                price = 12
              } else if (opti.num >= 2 && opti.num <= 5) {
                price = 40
              } else if (opti.num >= 6 && opti.num <= 8) {
                price = 60
              } else if (opti.num > 8) {
                let num = opti.num - 8
                price = 60
                price += num * 7
              }

              item.option.push(
                {
                  auto_calculate: 0,
                  checked: true,
                  edit: false,
                  is_overstep: 0,
                  name: `摄影(${opti.num}张)`,
                  name_translate: `写真(${opti.num}枚)`,
                  price_type: 0,
                  price,
                  num: 1,
                  unit: '元'
                }
              )

              item.option.splice(i, 1)
            }
            // 数组去重
            var hash = {};
            item.option = item.option.reduce(function (items, next) {
              hash[next.name]
                ? ""
                : (hash[next.name] = true && items.push(next));
              return items;
            }, []);
          })
        }

      })
      return list
    },
    //翻译单加入made in china
    addMadeInChina(list) {
      list.forEach(item => {
        // 定额会员及SVIP上的订单会员类型，提出报价时，所有番附加服务默认勾选上：made in china 贴付  
        if ((this.detail.attribute_name == '付费会员' || this.detail.attribute_name == 'SVIP') && this.detail.user.user_extend.allow_made_in) {
          if (item.option == null) {
            item.option = []
          }
          let FBAFlag = item.option.some(opti => opti.name == 'FBA贴标')
          let madeFlag = item.option.some(opti => opti.name == 'made in China')
          // if (i !== -1) {
          //   item.option.splice(i, 1)
          // }
          if (!FBAFlag && !madeFlag) {
            item.option.push(
              {
                auto_calculate: 0,
                checked: true,
                edit: false,
                is_overstep: 0,
                name: `made in China`,
                name_translate: `made in China`,
                price_type: 0,
                price: 0,
                num: item.num,
                unit: '元'
              }
            )
          }

          // 数组去重
          var hash = {};
          item.option = item.option.reduce(function (items, next) {
            hash[next.name]
              ? ""
              : (hash[next.name] = true && items.push(next));
            return items;
          }, []);
        }
      })
    },

  }
}
</script>
<style lang='scss' scoped>
.operate {
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 9;
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;

  /deep/ .el-button {
    margin-left: 5px;
  }
}
</style>